import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {createImgIn, setElementInnerHTML} from '../ui_utils/DomUtils.ts'
import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {createTooltipIn} from '../ui_utils/TooltipUtils.ts'
import {getProfilePopupElementId} from './UIViewProfilePopup.ts'

export class UIProfileOverviewController {
    private readonly username: HTMLHeadingElement
    private readonly pointsStat: HTMLHeadingElement
    private readonly winRatioStat: HTMLHeadingElement
    private readonly pgStat: HTMLHeadingElement
    private readonly karmaStat: HTMLHeadingElement
    private readonly totalGamesStat: HTMLLinkElement
    private readonly badgesContainer: HTMLDivElement

    constructor(isPopup: boolean = false) {
        const usernameId = getProfilePopupElementId('sticky_player_info_username', isPopup)
        const pointsStatId = getProfilePopupElementId('points_stat', isPopup)
        const winRatioStatId = getProfilePopupElementId('win_ratio_stat', isPopup)
        const pgStatId = getProfilePopupElementId('pg_stat', isPopup)
        const karmaStatId = getProfilePopupElementId('karma_stat', isPopup)
        const totalGamesStatId = getProfilePopupElementId('total_games_stat', isPopup)
        const badgesContainerId = getProfilePopupElementId('user-badges-container', isPopup)
        this.username = document.getElementById(usernameId) as HTMLHeadingElement
        this.pointsStat = document.getElementById(pointsStatId) as HTMLHeadingElement
        this.winRatioStat = document.getElementById(winRatioStatId) as HTMLHeadingElement
        this.pgStat = document.getElementById(pgStatId) as HTMLHeadingElement
        this.karmaStat = document.getElementById(karmaStatId) as HTMLHeadingElement
        this.totalGamesStat = document.getElementById(totalGamesStatId) as HTMLLinkElement
        this.badgesContainer = document.getElementById(badgesContainerId) as HTMLDivElement
    }

    setStats(data: AjaxDataTypes.PublicProfileDataOverview) {
        if(this.username != null) this.username.innerText = data.username
        this.pointsStat.innerText = String(data.gameData.pointsInLast100Games)
        this.winRatioStat.innerText = data.gameData.winPercent
        this.pgStat.innerText = data.gameData.pointsPerGame
        this.karmaStat.innerText = data.karma
        this.totalGamesStat.innerText = String(data.gameData.totalGames)

        this.setBadges(data.userId)
    }

    // Create legitimate system when more badges are added; static for now
    private setBadges(userId: string) {
        setElementInnerHTML(this.badgesContainer, {key: 'strings:colonistCommon.utils.emptyString'})

        const season11TournamentWinnerId = '19719305'
        const tournament4pWinnerIds = [
            '3208020', '94451747', '56604020', '51304747', '96441641', '61890847', '55031713', '99019802', '52067869', '99218961', '99247781',
            '66028376', '98791974', '61751886', '99200482', '98719794', '96620362', '57772422', '23034368', '59201781', '29049792', '61557587',
            '69054281', '85708590', '90997704', '54219086', '92602114', '96622700', '8770469', '7735637', '100621319', '100939283', '29911838',
            '18910613', '99285407', '99822064', '101290199',
        ]

        if(userId == season11TournamentWinnerId) UIProfileOverviewController.createBadge(this.badgesContainer, LobbyImage.TournamentS11First, {key: 'strings:profilePage.overview.badges.season11TournamentFirstTooltip'}, 'tournament-s11-first')
        if(tournament4pWinnerIds.includes(userId)) UIProfileOverviewController.createBadge(this.badgesContainer, LobbyImage.Tournament4P, {key: 'strings:profilePage.overview.badges.tournament4pTooltip'}, 'tournament-4p')
    }

    private static createBadge(badgesContainer: HTMLDivElement, badgeImage: LobbyImage, tooltipText: TranslationObject, badgeName: string) {
        const badge = createImgIn(badgesContainer, badgeImage)
        createTooltipIn(badge, tooltipText, 'right')
    }
}
